module.exports = __webpack_public_path__ + "static/media/corn.0f60319b.svg";